export default __webpack_public_path__ + "static/media/alejandro_wilcox.07e30aed.jpg";